// 用于滚动定位
// url中 增加pos参数，值是页面中的class或者ID
// tabpos 参数用于切换tab
// 依赖jquery
import $router from "./router";

var pos = {
    posName: null,
    tabPosName: null,
    setPos: function () {
        var _this = this;
        $(function () {
            //获取定位参数
            var posName = _this.posName || getUrlPara('pos');
            var tabPosName = _this.tabPosName || getUrlPara('tabpos');

            if (!posName) {
                return;
            }

            // 不使用滚动条的记录
            if ('scrollRestoration' in history) {
                // 默认值为'auto'
                history.scrollRestoration = 'manual';
            }

            //获取定位坐标
            setTimeout(function () {
                clickTab();
            }, 1000);

            function clickTab() {
                // var fixedPos = document.querySelector('.topbar').clientHeight * 2;

                if (posName) {
                    var $posClass = document.querySelector('.' + posName);
                    var $posId = document.querySelector('#' + posName);
                    var $pos = $posClass || $posId;
                    if (!$pos) {
                        return;
                    }
                    var posNum = $pos.offsetTop;
                    $('html, body').animate({ scrollTop: posNum }, 800)
                }

                if (tabPosName) {
                    var $tabpos = document.querySelector('.' + tabPosName);
                    if (!$tabpos) {
                        return;
                    }
                    document.querySelector('.' + tabPosName).click();
                }
            }


            //获取地址栏参数
            function getUrlPara(name) {
                var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
                var r = window.location.search.substr(1).match(reg);
                if (r !== null) {
                    return decodeURIComponent(r[2]);
                }
                return  false;
            }
        });
    },

    init: function (posName, tabPosName) {
        this.posName = posName;
        this.tabPosName = tabPosName;
        this.setPos();
    }
};

export default pos;
